import { render } from "./EmptySearch.vue?vue&type=template&id=7b784326&ts=true"
import script from "./EmptySearch.vue?vue&type=script&lang=ts"
export * from "./EmptySearch.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__